export const MAX_ITEMS = 5;
export const MAX_LABEL_LENGTH = 20;
export const FOCUS_TIMER_INTERVAL = 50;
export const DEFAULT_LABEL_ACCESSOR = 'label';
export const DEFAULT_ID_ACCESSOR = 'label';
